// import React from ''
import { FaqModuleLayout } from 'app/modules/faq-module/layout';
import React from 'react';
import { useTitle } from 'react-use';

export default function FaqModule() {
  useTitle(`AIDA - FAQ`);

  return <FaqModuleLayout />;
}
